import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { FileDto } from '../../services/dtos/file.dto';

/**
 * Boutton du tableau qui permet de visualiser ou télécharger un document
 * @constructor
 */
export default function OpenFile(
    props: Readonly<{
        handlerOpenFile: (file: FileDto) => void | Promise<void>;
        handlerDownloadFile: (file: FileDto) => void | Promise<void>;
        file: FileDto;
    }>
) {
    // Deux fonction, le premier pour visualiser le document dans la page, le second pour télécharger le doc
    return (
        <Stack direction="row" spacing={1} justifyContent="center">
            <Tooltip title="Visualiser">
                <IconButton
                    data-testid={'see-file'}
                    aria-label="Visualiser le document"
                    onClick={() => props.handlerOpenFile(props.file)}
                    size="small"
                    sx={{
                        border: '1px solid #d9e3ef',
                        borderRadius: '12px',
                        color: '#305b8d',
                    }}
                >
                    <SearchIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Telecharger">
                <IconButton
                    data-testid={'download-file'}
                    aria-label="Telecharger le document"
                    onClick={() => props.handlerDownloadFile(props.file)}
                    size="small"
                    sx={{
                        border: '1px solid #d9e3ef',
                        borderRadius: '12px',
                        color: '#305b8d',
                    }}
                >
                    <FileDownloadIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Stack>
    );
}
